import { Map } from 'immutable';
import { notificationListActions } from '../notifications-lists';
import { createNotification, Notification } from './notification';
import { notificationActions } from './actions';

export function notificationsReducer(state = new Map(), action) {
  const { type, payload } = action;
  switch (type) {
    case notificationListActions.FETCH_NOTIFICATIONS_SUCCESS:
      return state.withMutations( notifications => {
        payload.data.forEach( notificationData => {
          if (!notifications.has(notificationData.id)) {
            notifications.set(notificationData.id, createNotification(notificationData));
          }
        });
      });
    case notificationActions.FETCH_NOTIFICATION_SUCCESS:
    case notificationActions.FETCH_NOTIFICATION_PENDING:
      return state.set(
          payload.notificationId,
          notificationReducer(state.get(payload.notificationId), action)
        );
    case notificationActions.LOAD_NOTIFICATION:
      return state.merge({
        [payload.notificationId]: notificationReducer(state.get(payload.notificationId), action)
      });
    default:
      return state;
  }
}

export const notificationReducer = ( state = new Notification() , { payload, type }  ) => {
  switch (type) {
    case notificationActions.FETCH_NOTIFICATION_SUCCESS:
      return state.withMutations( efector => {
        efector.merge({
          isPending:false,
          dtLectura: new Date()
        });
      });
    case notificationActions.FETCH_NOTIFICATION_PENDING:
      return state.set('isPending', true);
    case notificationActions.LOAD_NOTIFICATION:
      return state.set('id', payload.notificationId);
    default:
      return state;
  }
}
